<template>
    <div class="commerce-card">
        <div class="container">
            <div class="card-title" v-if="cardArr != null">
                <h1>
                    <span class="project">{{ cardArr.project.name }}</span><span class="dot">.</span>
                    <span class="title">{{ cardArr.name}},</span> <span class="size">{{ cardArr.size }} м²</span>
                    <!-- <span class="class" v-if="isMobileChecker">{{ cardArr.type.name }}</span> -->
                </h1>
                <div class="card-adres-mobile" v-if="isMobileChecker">
                    <p v-html="cardArr.adres"></p>
                </div>
            </div>
            <div class="commerce-card-plan-content" v-if="cardArr != null && filterCMSparams != null">
                <div class="column-images">
                    <div class="images-nav">
                        <ul>
                            <li @click="active = 'plan'" :class="{'active' : active == 'plan'}" class="btn-wow-effect-hover"><span>{{ filterCMSparams.words_translation.plan_flat_card }}</span></li>
                            <li @click="active = 'gallery'" :class="{'active' : active == 'gallery'}" class="btn-wow-effect-hover" v-if="cardArr.images != false && cardArr.images != null && cardArr.images.length > 0"><span>{{ filterCMSparams.words_translation.gallery_commerce_card }}</span></li>
                        </ul>
                    </div>
                    <div class="btn-resize-plan btn-wow-effect-hover" @click="initResizeElem(cardArr.plan)" :class="{'hide' : active != 'plan'}">
                        <svgIcon name="resize" class="icon-resize"/>
                    </div>
                    <div class="card-adres" :class="{'gallery-adres' : active == 'gallery'}">
                        <p v-html="cardArr.adres"></p>
                    </div>
                    <div class="plan-img" v-if="active == 'plan'">
                        <img :src="cardArr.plan" alt="" v-if="cardArr.plan != null && cardArr.plan != ''">
                        <svgIcon name="none-img" class="icon-none-img" v-else/>
                    </div>
                    <div class="card-images-carousel" v-if="active == 'gallery'">
                        <swiper :options="swiperOption" ref="comemerceCardCarousel">
                            <swiper-slide v-for="(slide, index) in cardArr.images" :key="index">
                                <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                            </swiper-slide>
                        </swiper>

                        <div class="swiper-controls commerce-card-controls">
                            <div class="commerce-card-btn-prev slider-btn btn-wow-effect-hover">
                                <svgIcon name="arrow-left" class="icon-left-arrow"/>
                            </div>
                            <div class="commerce-card-btn-next slider-btn btn-wow-effect-hover">
                                <svgIcon name="arrow-right" class="icon-right-arrow"/>
                            </div>
                        </div>
                        <div class="swiper-pagination commerce-card-pagination"></div>
                    </div>
                </div>
                <div class="column-info">
                    
                    <div class="info-links" :class="{'notPlanStyle' : active != 'plan'}">
                        <div class="link-item" v-if="cardArr.pdf != false && cardArr.pdf != null">
                            <a :href="cardArr.pdf" target="_blank" download>
                                <svgIcon name="pdf" class="icon-pdf"/>
                            </a>
                        </div>
                        <div class="link-item link-item-share">
                            <div class="social-links-container">
                                <div class="soc-link-in">
                                    <SWhatsApp
                                        :share-options="{
                                            text: cardArr.name + ', ' +  cardArr.size + 'м², в жилом комплексе ' +  cardArr.project.name + ', ' + 'https://dialgroup.kz/commerce/' + cardID
                                        }"
                                        :use-native-behavior="true"
                                    ><svgIcon name="wapp" class="icon-soc icon-wapp"/></SWhatsApp>
                                    <STelegram
                                        :share-options="{
                                            text: cardArr.name + ', ' +  cardArr.size + 'м², в жилом комплексе ' +  cardArr.project.name,
                                            url: 'https://dialgroup.kz/commerce/' + cardID
                                        }"
                                        :use-native-behavior="true"
                                    ><svgIcon name="telapp" class="icon-soc icon-telapp"/></STelegram>
                                </div>
                            </div>
                            <svgIcon name="share" class="icon-share"/>
                        </div>
                        <div class="link-item link-favorite">
                            <svgIcon name="favorite-disactive" class="icon-favorite"/>
                            <svgIcon name="favorite-active" class="icon-favorite-active"/>
                        </div>
                        <div class="link-item btn-consult" @click="openFormConsult(cardArr)">
                            <span v-if="globalLang != 'kz/'">Оставить заявку</span>
                            <span v-else>Өтінім қалдыру</span>
                            <svgIcon name="arrow-right" class="icon-right-arrow"/>
                        </div>
                    </div>
                    <div class="info-head">
                        <h2>
                            <span>{{ cardArr.name }}</span> 
                        </h2>
                        <div class="calss" v-if="cardArr.type != false && cardArr.type != null"><span>{{ cardArr.type.name }}</span></div>
                    </div>
                    <div class="info-list">
                        <ul>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.project }}</div>
                                <div class="info-value info-value-project">{{ cardArr.project.name }}</div>
                            </li>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.part }}</div>
                                <div class="info-value">{{ parseInt(cardArr.part.label) }}</div>
                            </li>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.level }}</div>
                                <div class="info-value">{{ formatArray(cardArr.level) }}</div>
                            </li>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.size }}</div>
                                <div class="info-value size-value">{{ cardArr.size }} <span v-if="isMobileChecker">м²</span></div>
                            </li>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.height }}</div>
                                <div class="info-value size-value">{{ cardArr.height }} <span v-if="isMobileChecker">м²</span></div>
                            </li>
                            <li v-if="cardArr.rent == 'true'">
                                <div class="info-label">{{ filterCMSparams.words_translation.rent }}</div>
                                <div class="info-value size-value">{{ getNumber(cardArr.rent_price) }} <span>тг</span></div>
                            </li>
                        </ul>
                    </div>
                    <div class="info-price">
                        <div class="price-full"><span>{{ getNumber(cardArr.price_full) }}</span> тг</div>
                    </div>
                    <!-- <div class="btn-consult" @click="openFormConsult(cardArr)">
                        <span v-if="globalLang != 'kz/'">Оставить заявку</span>
                        <span v-else>Өтінім қалдыру</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </div> -->
                </div>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <flatsCardResizeElem v-if="resizeInit"></flatsCardResizeElem>
        </transition>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import store from '@/store.js'
    import flatsCardResizeElem from '@/components/flats-page/flats-card-resize-elem.vue'
    import formPage from '@/components/forms/form-page.vue'
    import { STelegram, SWhatsApp } from 'vue-socials'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'commerce--card',
        components: {
            // flatsFilter,
            flatsCardResizeElem,
            formPage,
            svgIcon,
            SWhatsApp,
            STelegram,
        },
        data () {
            return {
                visible: false,
                globalLang: window.GlobalLang, 
                cardID: this.$route.params.id,
                cardArr: null,
                active: 'plan',
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.commerce-card-btn-next',
                        prevEl: '.commerce-card-btn-prev',
                    },
                    pagination: {
                        el: '.commerce-card-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            filterCMSparams: 'loadFilterCMSparams',
            // flatsItemsArr: 'loadFlatsItems',
            // flatsListView: 'loadFlatsListView',
            // filterFlatsDataBase: 'loadFilterFlatsData',
            // isOpenFilterMobile: 'loadOpenFlatsMobileFilter',
            isMobileChecker: 'loadIsMobileChecker',
            resizeInit: 'loadFlatsResizeElemInit',
            // aboutPage: 'loadAboutPage',
        }),
        methods: {
            initResizeElem(plan) {
                this.$store.commit('flatsResizeElemInit', true);
                this.$store.commit('flatsResizeImgSet', plan);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('visibilityHide');
                document.getElementById('footer').classList.add('visibilityHide');
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
            openFormConsult(arr) {
                
                // console.log(arr)
                var dataArr = {
                    name_card: arr.name,
                    adres: arr.adres,
                    project: arr.project.name,
                    id: this.cardID,
                    part: arr.part.label,
                    level: arr.level,
                    // type: arr.type.name,
                    size: arr.size + ' м²',
                    price: this.getNumber(arr.price_full) + ' тг.',
                    link: 'https://dialgroup.kz/commerce/' + this.cardID,
                };
                // console.log(dataArr, 'form data arr')
                this.$store.commit('formsModalRealEstate_setData', dataArr);
                this.$store.commit('formGlobalDataModal_set', {'page' : 'commerce-card', 'block' : 'Информация о коммерции'});
                this.$store.commit('formGlobalParam_set', 'commerce-form');
                this.$store.commit('formModalContainerOpen');
            },  
            getMinMaxFloor(floor) {
                const numbers = floor.map(Number);
                if (numbers.length === 1) {
                    return `${numbers[0]}`;
                }
                const min = Math.min(...numbers);
                const max = Math.max(...numbers);
                return min === max ? `${min}` : `${min} & ${max}`;
            },
            formatArray(arr) {
                if (!Array.isArray(arr) || arr.length === 0) {
                return ""; // Возвращаем пустую строку, если массив пустой
                }
                return arr.join(", ");
            }
        },
        beforeRouteEnter (to, from, next) {
            // console.log(to);
            // store.dispatch('getNewsItems');
            // store.dispatch('getNewsPageData');
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/commerce/' + to.params.id).then(async (response) => {
                // console.log(response, 'comerce card');
                if (response.data.length != 0) {
                    next(vm => {
                        vm.cardArr = response.data.acf;
                        // vm.$store.commit('removePageLoaderImg');
                        // vm.$parent.$refs.topProgress.done();
                    });
                } else {
                    next('/404');
                    //PUSH ON 404 PAGE
                }
            });
        },
        beforeCreate() {
            // this.$store.dispatch('getFlatsItems');
            document.body.dataset.page = 'commerce-card';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/commerce-page/commerce-card.scss';
    @import '@/styles/components/commerce-page/respond/commerce-card-respond.scss';
</style>